export default setFieldValues => item => {
  setFieldValues({
    statisticId: item._id,
    statisticName: item.name,
    scoreUnit: item.scoreUnit,
  });
};
